<template>
  <div class="SurveyCard card">
    <div class="card__section">
      <ExpandableDetail>
        <template v-slot:summary>
          <h5 class="text-blue text-upper text-small">
            <span class="text-small">{{ survey.name }}</span>
          </h5>

          <p v-html="survey.descriptionHtml" />
        </template>

        <template v-slot:detail>
          <template v-for="question in survey.questions">
            <div class="SurveyCard__Question card__section card__section--bordered">
              <p>Question: {{question.text}}</p>
              <p>{{question.qType}}</p>
              <ul>
                <li v-for="opt in question.answerOptions">{{opt.text}}</li>
              </ul>

              <div class="SurveyCard__FeatureFlag">
                <span class="SurveyCard__FeatureFlag__Label">
                  Is Archived?
                </span>
                <span>{{ question.isArchived ? 'YES' : 'NO' }}</span>
              </div>

              <div class="SurveyCard__FeatureFlag">
                <span class="SurveyCard__FeatureFlag__Label">
                  Is Optional?
                </span>
                <span>{{ question.isOptional ? 'YES' : 'NO' }}</span>
              </div>
            </div>
          </template>
        </template>
      </ExpandableDetail>
    </div>
  </div>
</template>

<script>
import FeatureFlag from '@/components/FeatureFlag'
import ExpandableDetail from '@/components/ExpandableDetail'

export default {
  name: 'SurveyCard',
  components: {
    FeatureFlag,
    ExpandableDetail,
  },
  props: {
    survey: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../styles/variables';
@import '../../styles/mixins/cards';

.card {
  @include card;
}

.SurveyCard {
  margin-bottom: 24px;
}

.SurveyCard__Question {
  margin-top: 12px;
}

.SurveyCard__FeatureFlag {
  display: flex;
  align-content: center;
  margin-top: 12px;
  margin-bottom: 12px;

  /** Unknown why this is needed for FeatureFlag to render correctly
      inside of a detail/summary element, but it seems to be needed **/
  box-sizing: border-box;
}

.SurveyCard__FeatureFlag__Label {
  margin-right: 12px;
  font-weight: bold;
}
</style>

